export default __webpack_public_path__ + "static/media/singapore.4e7a94af.jpg";